import { render, staticRenderFns } from "./OneApi.vue?vue&type=template&id=2bc42aeb&"
import script from "./OneApi.vue?vue&type=script&lang=js&"
export * from "./OneApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports